// Fallback index.js for TerrPerformance to support .js extension import
import TerrPerformance from './TerrPerformance.jsx';
export default TerrPerformance;
